module.exports = __webpack_public_path__ + "img/club-de-golf-pachuca.70c5b9b2.jpg";